'use strict';//Indicating browser should run only in java script mode
; (function () {

    var addEditRuleOutViewModuleRoutes = [
        {
            "name": "AddEditRuleOutView",
            "url": "AddEditRuleOutView",
            "templateUrl": "AngularScripts/AddEditRuleOutView/Htmls/AddEditRuleOutView.html",
            "RoutingNumber": 4695,
            files: [
                "AngularScripts/AddEditRuleOutView/Services/AddEditRuleOutViewService.js",
                "AngularScripts/AddEditRuleOutView/Controllers/AddEditRuleOutViewController.js",
            ]
        }, 

    ];
    angular.module('EMR.AddEditRuleOutViewModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(addEditRuleOutViewModuleRoutes, $stateProvider);
            }]);
})();
